import request from "@/utils/request";
import ds, {dsc, ___} from '../utils/daoService/DaoServiceClientES6Adapter'
const ebOrder = ds.QEbOrder.using(dsc)

export function queryByNo(searchData) {
  return ebOrder.select(ebOrder.fieldContainer())
    .paging(searchData.page, searchData.limit)
    .where(searchData.whereObj)
    .tag('queryEbOrder')
    .execute(searchData.valueObj)
}

export function queryByVgmOrderId(ebOrderId) {
  return request({
    url: '/web/vgmManage/queryEbOrderByVgmOrderId?ebOrderId=' + ebOrderId,
    method: 'get',
    data: ebOrderId
  })
}
  export function saveEbCtnAdDradt(ebCtnForm) {
    return request({
      url: '/web/vgmManage/saveEbCtnAdDradt',
      method: 'post',
      data:ebCtnForm
    })
  }
export function queryCtnByVgmOrderId(ebOrderId) {
  return request({
    url: '/web/vgmManage/queryCtnByVgmOrderId?ebOrderId='+ebOrderId,
    method: 'get',
    data:ebOrderId
  })
}

export function batchDeleteEbOrder(ebCtnIds) {
  return request({
    url: '/web/vgmManage/batchDeleteEbOrder',
    method: 'post',
    data:ebCtnIds
  })
}

export function queryEbOrderByConditions(searchData) {
  return request({
    url: '/web/vgmManage/queryEbOrderByConditions',
    method: 'post',
    data: searchData
  })
}
  export function queryEbOrder(no) {
    return request({
      url: '/web/vgmManage/queryEbOrder?no='+no,
      method: 'get',
      data:no
    })
  }

export function queryMoreEbOrder(searchDate) {
  return request({
    url: '/web/vgmManage/queryMoreEbOrder',
    method: 'post',
    data:searchDate
  })
}

export function batchSubmitVGM(ebOrders) {
  return request({
    url: '/web/vgmManage/batchSubmitVGM',
    method: 'post',
    data:ebOrders
  })
}


export function sumbitEbOrderAndEbFtPlan(ebCtn) {
  return request({
    url: '/web/vgmManage/sumbitEbOrderAndEbFtPlan',
    method: 'post',
    data:ebCtn
  })
}

export function judgeWhetherDeleteEbCtns(ebCtnIds) {
  return request({
    url: '/web/vgmManage/judgeWhetherDeleteEbCtns',
    method: 'post',
    data: ebCtnIds
  })
}

export function saveEbOrder(ebOrder) {
  return request({
    url: '/web/vgmManage/saveEbOrder',
    method: 'post',
    data: ebOrder
  })
}
